import axios from 'axios';
import authHeader from "@/service/auth-header";

class ProductService {

    getCompanyProducts(companyId) {
        return axios.get(`/api/product1/${companyId}`, {headers: authHeader()})
    }

    searchProducts(companyId, productName) {
        return axios.get(`/api/product1/${companyId}/${productName}`, {headers: authHeader()})
    }

    getProduct(productId) {
        return axios.get(`/api/product1/specific/${productId}`, {headers: authHeader()})
    }

    createProduct(companyId, data) {
        return axios.post(`/api/product1/${companyId}`, data, {headers: authHeader()});
    }

    updateProduct(productId, data) {
        return axios.put(`/api/product1/${productId}`, data, {headers: authHeader()});
    }

    deleteProduct(productId) {
        return axios.delete(`/api/product1/${productId}`, {headers: authHeader()})
    }

}

export default new ProductService();
